// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rank`
};

const de_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Rang`
};

const es_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rango`
};

const fr_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rang`
};

const fi_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `sija`
};

const hi_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `रैंक`
};

const ja_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `順位`
};

const nl_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rangschikking`
};

const pt_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `classificação`
};

const ro_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rang`
};

const th_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `อันดับ`
};

const ur_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `رینک`
};

const zh_hant1_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `排名`
};

const da_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rang`
};

const it_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `posizione`
};

const vn_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `xếp hạng`
};

const ko_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `순위`
};

const tr_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `sıralama`
};

const lv_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rangs`
};

const ar_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `الترتيب`
};

const bs_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rang`
};

const sl_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `mesto`
};

const id_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `peringkat`
};

const sv_widget_leaderboard_rank = /** @type {(inputs: {}) => string} */ () => {
	return `rang`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_rank = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_rank(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_rank", locale)
	if (locale === "en") return en_widget_leaderboard_rank(inputs)
	if (locale === "de") return de_widget_leaderboard_rank(inputs)
	if (locale === "es") return es_widget_leaderboard_rank(inputs)
	if (locale === "fr") return fr_widget_leaderboard_rank(inputs)
	if (locale === "fi") return fi_widget_leaderboard_rank(inputs)
	if (locale === "hi") return hi_widget_leaderboard_rank(inputs)
	if (locale === "ja") return ja_widget_leaderboard_rank(inputs)
	if (locale === "nl") return nl_widget_leaderboard_rank(inputs)
	if (locale === "pt") return pt_widget_leaderboard_rank(inputs)
	if (locale === "ro") return ro_widget_leaderboard_rank(inputs)
	if (locale === "th") return th_widget_leaderboard_rank(inputs)
	if (locale === "ur") return ur_widget_leaderboard_rank(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_rank(inputs)
	if (locale === "da") return da_widget_leaderboard_rank(inputs)
	if (locale === "it") return it_widget_leaderboard_rank(inputs)
	if (locale === "vn") return vn_widget_leaderboard_rank(inputs)
	if (locale === "ko") return ko_widget_leaderboard_rank(inputs)
	if (locale === "tr") return tr_widget_leaderboard_rank(inputs)
	if (locale === "lv") return lv_widget_leaderboard_rank(inputs)
	if (locale === "ar") return ar_widget_leaderboard_rank(inputs)
	if (locale === "bs") return bs_widget_leaderboard_rank(inputs)
	if (locale === "sl") return sl_widget_leaderboard_rank(inputs)
	if (locale === "id") return id_widget_leaderboard_rank(inputs)
	if (locale === "sv") return sv_widget_leaderboard_rank(inputs)
	return "widget_leaderboard_rank"
};